import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from '@reduxjs/toolkit/query/react';

const baseUrl = `${baseURL}/users/`;


export const userApiService = createApi({
    reducerPath: 'userApi',
    baseQuery: fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const authState = getState().authSlice;
            const { token, user } = authState;
            
            // Try to get token from multiple sources
            const currentToken = token || user?.token;
            
            if (currentToken) {
                headers.set('Authorization', `Bearer ${currentToken}`);
            } else {
                console.warn("API Headers - No token found in any source");
            }
            
            headers.set('Content-Type', 'application/json');
            return headers;
        },
    }),
    endpoints: (builder) => ({
        register: builder.mutation({
            query: (payload) => ({
                url: `${baseURL}/auth/signup`,
                method: 'POST',
                body: payload,
            }),
        }),
        // Fetch all addresses for a user
        getUserAddresses: builder.query({
            query: (userId) => ({
                url: `${userId}/shipping-addresses`,
                method: 'GET',
            }),
        }),

        // Get specific address for a user
        getUserAddress: builder.query({
            query: ({ userId, addressId }) => ({
                url: `${userId}/shipping-addresses/${addressId}`,
                method: 'GET',
            }),
        }),

        // Add new address for a user
        addUserAddress: builder.mutation({
            query: ({ userId, addressLine1, addressLine2, city, postalCode, phone, country }) => ({
                url: `${userId}/shipping-addresses`,
                method: 'POST',
                body: {
                    addressLine1,
                    addressLine2,
                    city,
                    postalCode,
                    phone,
                    country
                },
            }),
        }),

        // Update a specific address for a user
        updateUserAddress: builder.mutation({
            query: ({ userId, addressId, addressLine1, addressLine2, city, postalCode, phone, country }) => ({
                url: `${userId}/shipping-addresses/${addressId}`,
                method: 'PUT',
                body: {
                    addressLine1,
                    addressLine2,
                    city,
                    country,
                    postalCode,
                    phone,
                },
            }),
        }),

        // Delete a specific address for a user
        deleteUserAddress: builder.mutation({
            query: ({ userId, addressId }) => ({
                url: `${userId}/shipping-addresses/${addressId}`,
                method: 'DELETE',
            }),
        }),
        updateUserDetails: builder.mutation({
            query: ({ userId, first_name, last_name, phone }) => {

                return {
                    url: `${userId}`, // URL structure for updating user details
                    method: 'PUT',
                    body: {
                        first_name,
                        last_name,
                        phone,
                    },
                };
            },
        }),
        changePassword: builder.mutation({
            query: ({ currentPassword, newPassword }) => ({
                url: `${baseURL}/auth/change-password`,
                method: 'POST',
                body: {
                    currentPassword,
                    newPassword,
                },
            }),
        }),
    }),
});

export const {
    useRegisterMutation,
    useGetUserAddressesQuery, // Get all addresses for a user
    useGetUserAddressQuery, // Get specific address for a user
    useAddUserAddressMutation, // Add new address for a user
    useUpdateUserAddressMutation, // Update specific address for a user
    useDeleteUserAddressMutation, // Delete specific address for a user
    useUpdateUserDetailsMutation,
    useChangePasswordMutation,
} = userApiService;
